import Vue from 'vue';
import purchaseTransformer from './../../transformers/purchase';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentPurchase', purchaseTransformer.fetch(data));
  resolve(purchaseTransformer.fetch(data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(purchaseTransformer.fetch(errors));
};

export default (id, purchase) => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`/purchases/save-as-draft/${id}`, purchase)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/purchase/saveAsDraft.js